import { render } from "./multi-file-upload-wrapper.vue?vue&type=template&id=5572a96f"
import script from "./multi-file-upload-wrapper.vue?vue&type=script&lang=js"
export * from "./multi-file-upload-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__